import { Directive, ElementRef, OnDestroy, OnInit, inject, Renderer2 } from '@angular/core';
import { UserNotificationsService } from './user-notifications.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appUserNotificationsQtyBullet]',
    standalone: true
})
export class UserNotificationsQtyBulletDirective implements OnInit, OnDestroy {
    private subscription = new Subscription();
    private elementRef = inject(ElementRef);
    private renderer = inject(Renderer2);
    private userNotificationsService = inject(UserNotificationsService);

    ngOnInit(): void {
        this.subscription.add(
            this.userNotificationsService.notifications$.subscribe(notifications => {
                const count = notifications.length;
                this.updateAttributes(count);
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private updateAttributes(count: number): void {
        const element = this.elementRef.nativeElement;

        if (count === 0) {
            this.renderer.removeAttribute(element, 'qty-bullet');
            this.renderer.removeAttribute(element, 'aria-label');
        } else {
            this.renderer.setAttribute(element, 'qty-bullet', count.toString());
            this.renderer.setAttribute(element, 'aria-label', `${count} unread notifications`);
        }
    }
}
